<template>
  <AuthWrapper>
    <div class="auth-contents">
      <a-form @finish="handleSubmit" :model="formState" layout="vertical" v-if="!isChecking">
        <sdHeading as="h3">{{ $t('pages.reset-password.title') }}</sdHeading>
        <p class="forgot-text">{{ $t('pages.reset-password.text') }}</p>
        <a-form-item :label="$t('pages.reset-password.password')" name="password">
          <a-input type="password" v-model:value="formState.password" />
        </a-form-item>
        <a-form-item :label="$t('pages.reset-password.password-confirm')" name="passwordConfirm">
          <a-input type="password" v-model:value="formState.passwordConfirm" />
        </a-form-item>
        <a-form-item>
          <sdButton class="btn-reset" htmlType="submit" type="primary" size="large" :disabled="isLoading">
            {{ isLoading ? $t('common.loading') : $t('pages.reset-password.change-btn') }}
          </sdButton>
        </a-form-item>
        <p class="return-text">{{ $t('pages.reset-password.return-to') }} <router-link to="/auth/login">{{ $t('pages.reset-password.sign-in') }}</router-link></p>
      </a-form>
    </div>
  </AuthWrapper>
</template>
<script>
import { AuthWrapper } from './style';
import axios from 'axios';
import { notification } from 'ant-design-vue';

export default {
  name: 'ResetPassword',
  components: { AuthWrapper },
  data() {
    return {
      formState: {
        password: '',
        passwordConfirm: '',
        password_token: '',
      },
      isLoading: false,
      isChecking: true,
    };
  },
  methods: {
    handleSubmit() {
      if (this.formState.password != this.formState.passwordConfirm) {
        notification.error({
          message: 'Şifreler birbiriyle uyuşmamaktadır',
        });
        return;
      }
      this.isLoading = true;
      var _this = this;
      axios
        .post(process.env.VUE_APP_API_ENDPOINT +  this.$endpoints.auth_password_reset, this.formState)
        .then(response => {
          if (response.data.status === true) {
            notification.success({
              message: 'Password updated successfully',
            });
            _this.$router.push('/auth/login');
          } else {
            notification.error({
              message: response.data.message,
            });
          }
        })
        .catch(e => {
          notification.error({
            message: 'Error',
          });
        });
      this.isLoading = false;
    },
  },
  created() {
    if (this.$route.query.token != undefined) {
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + this.$endpoints.auth_password_check, {
          password_token: this.$route.query.token,
        })
        .then(response => {
          if (response.data.status == true) {
            this.formState.password_token = this.$route.query.token;
            this.isChecking = false;
          } else {
            notification.error({
              message: 'Invalid Request',
            });
          }
        })
        .catch(e => {
          notification.error({
            message: 'Error',
          });
        });
    } else {
      notification.error({
        message: 'Invalid Request',
      });
    }
  },
};
</script>
